import { MethodConstants } from '../../constants/constants'
import { useMutation } from '@tanstack/react-query'
import { createFeedback } from '../../queries/feedback/feedback'
import { useEssentials } from 'hooks/utils/useEssentials'

export const useCreateFeedback = (
    onSuccess?: () => void,
    onError?: () => void,
) => {
    const { currentLocation, session, env } = useEssentials()

    const { lanId } = session?.userInfo ?? {
        lanId: '',
    }
    const accessToken = session?.accessToken ?? ''
    const mutation = useMutation({
        retry: false,
        mutationFn: (comments: string) => {
            const data = {
                lanId: lanId,
                env,
                accessToken: accessToken,
                method: MethodConstants.POST,
                body: {
                    feedback_ease_of_use: 0,
                    feedback_meets_needs: 0,
                    lan_id: lanId,
                    feedback_location: currentLocation,
                    feedback_comments: comments,
                },
            }

            return createFeedback(data)
        },
        onSuccess,
        onError,
    })

    return mutation.mutate
}
